export default "__VITE_ASSET__D8XpVHT2__"